import {Notification} from 'element-ui'
import * as mqttConn from 'mqtt';

// MQTT连接配置
const mqtt = {
    client: null,
    topic: null,
    config: {
        // endpoint: "/mqtt",
        reconnectPeriod: 4000, // ms
        keepalive: 60,
        clean: true,
        // 可以添加更多的配置项，如用户名、密码等
        username: "spread",
        password: "spread123",
        clientId: "Spread-Wes3-" + Math.random().toString(16),
    },

    connectMqtt: connectMqtt,
    subscribe: subscribe,
    publish: publish,
    disconnectMqtt: disconnectMqtt,
};

// 封装连接方法
function connectMqtt(topic) {
    if (mqtt.client && mqtt.client.connected) {
        return;
    }
    if (mqtt.client) {
        console.log(mqtt.client.connected)
    }
    // MQTT服务器地址
    const MQTT_URL = 'wss://mqtts-la.spreadlogistics.com:8084/mqtt';
    // 创建MQTT客户端实例
    mqtt.client = mqttConn.connect(MQTT_URL, mqtt.config);
    mqtt.client.on('connect', () => {
        console.log('MQTT connected');
        console.log(mqtt.client);
        Notification({
            type: 'success',
            title: 'MQTT',
            message: 'MQTT connected.'
        });
        if (topic) {
            this.subscribe(topic)
        }
    });

    mqtt.client.on('message', (topic, message) => {
        console.log(`Received message: ${message.toString()} from topic: ${topic}`);
        // 处理接收到的消息
    });

    mqtt.client.on('error', (err) => {
        console.error('MQTT error:', err);
        // 处理错误
        Notification({
            type: 'error',
            title: 'MQTT',
            message: 'MQTT error:' + err
        });
    });
}

// 封装订阅方法
function subscribe(topic) {
    mqtt.client.subscribe(topic, (err) => {
        if (err) {
            console.error('Subscription error:', err);
            Notification({
                type: 'error',
                title: 'MQTT',
                message: 'Subscription error:' + err
            });
        } else {
            console.log(`Subscribed to topic: ${topic}`);
            this.topic = topic
            Notification({
                type: 'success',
                title: 'MQTT',
                message: `Subscribed to topic: ${topic}`
            });
        }
    });
}

// 封装发布消息方法
function publish(topic, message) {
    mqtt.client.publish(topic, message, (err) => {
        if (err) {
            console.error('Publish error:', err);
            Notification({
                type: 'error',
                title: 'MQTT',
                message: 'Publish error:' + err
            });
        } else {
            console.log(`Message[` + message + `] published to topic: ${topic}`);
        }
    });
}

// 封装断开连接方法
function disconnectMqtt() {
    mqtt.client.end(true, () => {
        console.log('MQTT disconnected');
        // 断开连接后的操作
        Notification({
            type: 'error',
            title: 'MQTT',
            message: 'MQTT disconnected.'
        });
    });
}

export default mqtt
